const empresa_listar = {
	name: "empresa-listar",
	path: "/empresas",
	component: () =>
		import("@/views/empresa/empresa_listar/Empresas.vue"),
	meta: {
		// # TODO adicionar permissao correta
		rule: ["autenticadover", "autenticadosuperuser", "empresavisualizar"]
	}
};

const empresa_adicionar = {
	name: "empresa-adicionar",
	path: "/empresas/adicionar",
	component: () =>
		import("@/views/empresa/empresa_adicionar/EmpresaAdicionar.vue"),
	meta: {
		// # TODO adicionar permissao correta
		rule: ["autenticadosuperuser"]
	}
};

const empresa_editar = {
	name: "empresa-editar",
	path: "/empresas/:pk/editar",
	component: () =>
		import("@/views/empresa/empresa_editar/EmpresaEditar.vue"),
	meta: {
		// # TODO adicionar permissao correta
		rule: ["autenticadosuperuser"]
	}
};

export default [
	empresa_listar,
	empresa_adicionar,
	empresa_editar,
];
